module.exports = __webpack_public_path__ + "img/jiushui.331e945e.png";